import React, { Component } from 'react';
import Spinner from 'react-spinkit';
import { authRef } from '../reference';

export default class ResetPassword extends Component {
  state = {
    email: null,
    error: '',
    password: '',
    success: false,
    validCode: null,
    verifiedCode: false,
  }
  //navigateTo = () => window.location.href = 'http://localhost:8100/';
   navigateTo = () => window.location.href='https://www.myhandyplus.com/';
  navigateToFB = 'https://www.facebook.com/myhandyplus/';
  navigateToInsta = 'https://www.instagram.com/myhandyplus/';
  navigateToEmail = () => window.location.href = 'contact@myhandyplus.com';



  
  componentDidMount() {
    // Verify the password reset code is valid.
    authRef
      .verifyPasswordResetCode(this.props.actionCode)
      .then(email => {
        this.setState({ email, validCode: true, verifiedCode: true });
      }, error => {
        // Invalid or expired action code. Ask user to try to reset the password
        // again.
        this.setState({ error: error.message, validCode: false, verifiedCode: true });
      });
  }

  handleResetPassword = (event) => {
    event.preventDefault();
    const { actionCode } = this.props;
    const newPassword = this.state.password;

    // Save the new password.
    authRef
      .confirmPasswordReset(actionCode, newPassword)
      .then(() => {
        // Password reset has been confirmed and new password updated.
        this.setState({ success: true });
      }, error => {
        // Error occurred during confirmation. The code might have expired or the
        // password is too weak.
        this.setState({ error: error.message });
      });
  }

  setText = (evt) => {
    this.setState({ password: evt.target.value });
  }


  render() {
    const {
      email,
      error,
      password,
      success,
      validCode,
      verifiedCode,
    } = this.state;

    let component;
    if (!verifiedCode) {
      component = <Spinner spinnerName="three-bounce" />;
    } else if (success) {

      //history.push('/componentURL');
      component = (


        < div className="body">
          <div className="div-logo">
            <div className="img-logo" ></div>
          </div>

          <div className="content">
            <h1>Bienvenue dans la team de Myhandyplus 🥳</h1>

            <p> Ton aventure gratuite commence içi 🤩 Sache que notre équipe sera là pour t'aider et te donner nos meilleurs conseils afin que tu puisses faire de belles rencontres.</p>
            <p>Alors <span className="B">Conseil Numéro 1 :</span> Complète au max ton profil, renseigne ta ville si tu veux faire des rencontres près de chez toi. Dis nous en un peu plus sur ta personnalité, ta façon de vivre et ta vision de la vie. C'est important pour faire de belles rencontres.<span className="B">Et n'oublies pas de mettre ta PHOTO, on est sur le web et personne ne veut parler à un fantôme</span> 👻 </p>
            <p><span className="B">Conseil Numéro 2 :</span> Myhandyplus est un site sérieux, tous nos profils sont vérifiés, on fait la chasse aux sorcières lol. Alors utilise l'option de blocage si tu as un doute sur un profil. Nos équipes en seront automatiquement informées.</p>
            <p><span className="B">Conseil Numéro 3 :</span> Nous allons te proposer chaque jour de nouveaux profils qui pourraient t'intéresser. Fais le premier pas en envoyant un message 🤩</p>
            <p>Sache que l'équipe de Myhandyplus met tout en oeuvre pour te proposer le meilleur service possible.</p>
            <p>N'hésite pas à nous contacter pour toute remarque afin d'améliorer le service qui t'ait proposé.</p>
            <p>Soutien nous et rejoins la communauté sur les réseaux Facebook & Instagram.</p>


            <button className="btnJoin-us" onClick={this.navigateTo} type="button" > Rejoignez-nous ! </button>

            <div className="div-coach">
              <div className="img-coach"></div>
              <p className="right"> Votre coach MyHandyPlus</p>
            </div>

          </div>


          <div className="footer">
            <div className="div1-footer">
              <a href={this.navigateToFB} target="_blank">  Facebook </a>
              <a href={this.navigateToInsta} target="_blank">  Instagram  </a>
            </div>
            <div className="div2-footer">
              <p className="B">Contactez-nous :</p>
              <p>contact@myhandyplus.com</p>
              <p>Ce courriel est envoyé automatiquement, merci de ne pas utiliser la fonction " répondre à l'expéditeur ".</p>
              <p>Si vous ne souhaitez ne plus recevoir d'emails de la part de Myhandyplus, vous pouvez <span className="text-souligner">vous désabonner</span>.</p>
            </div>

          </div>



        </div>



      );
    } else if (verifiedCode && validCode) {
      component = (

        < div className="body">
        <div className="div-logo">
          <div className="img-logo" ></div>
        </div>

        <div className="content">
          <h1>Bienvenue dans la team de Myhandyplus 🥳</h1>

          <div className="ResetPassword">
            <h1>Initialiser le mot de passe MyhandyPlus </h1>
            <div>de : <span>{email}</span></div>

            <form onSubmit={this.handleResetPassword}>

              {error ? <div className="error">{error}</div> : ''}

              <input
                onChange={this.setText}
                value={password}
                type="password"
                placeholder="Nouveau mot de passe"
                required
              />
              <input
                type="submit"
                value="Sauvegarder"
              />
            </form>
          </div>

          <div className="div-coach">
            <div className="img-coach"></div>
            <p className="right"> Votre coach MyHandyPlus</p>
          </div>

        </div>


        <div className="footer">
          <div className="div1-footer">
            <a href={this.navigateToFB} target="_blank">  Facebook </a>
            <a href={this.navigateToInsta} target="_blank">  Instagram  </a>
          </div>
          <div className="div2-footer">
            <p className="B">Contactez-nous :</p>
            <p>contact@myhandyplus.com</p>
            <p>Ce courriel est envoyé automatiquement, merci de ne pas utiliser la fonction " répondre à l'expéditeur ".</p>
            <p>Si vous ne souhaitez ne plus recevoir d'emails de la part de Myhandyplus, vous pouvez <span className="text-souligner">vous désabonner</span>.</p>
          </div>

        </div>



      </div>







      );
    } else if (verifiedCode && !validCode) {
      component = (
        <div className="ResetPassword">
          <h1>Try resetting your password again</h1>
          <p className="error">{error}</p>
        </div>
      );
    }

    return component;
  }


}



// WEBPACK FOOTER //
// ./src/components/ResetPassword.js